export default {
  // header
  'develop': 'Develop',
  'representative': 'Representative',
  'resources': 'Resources',
  'maroscan': 'Maro scan',
  'menu': 'menu',
  'close': 'close',

  // footer
  'footer_home': 'Home',
  'footer_about': 'About',
  'footer_ecosystem': 'Ecosystem',
  'footer_developer': 'Developer',
  'footer_media': 'Social media',
  'about_contant4_time1': 'July, 2020',
  'about_contant4_time1_txt1': 'Maro Rebranding',
  'about_contant4_time2': 'June, 2020',
  'about_contant4_time2_txt1': 'WorkBox Launched',
  'about_contant4_time3': 'March, 2020',
  'about_contant4_time3_txt1': 'Over  10,000,000 blocks produced',
  'about_contant4_time4': 'December, 2019',
  'about_contant4_time4_txt1': 'Stablecoin Launched',
  'about_contant4_time5': 'September, 2019',
  'about_contant4_time5_txt1': 'Tigris Protocol Launched',
  'about_contant4_time6': 'August, 2019',
  'about_contant4_time6_txt1': 'Acorn Protocol Beta Launched',
  'about_contant4_time7': 'July, 2019',
  'about_contant4_time7_txt1': 'Slave Network Launched',
  'about_contant4_time8': 'April, 2019',
  'about_contant4_time8_txt1': 'Maro Connect Launched',
  'about_contant4_time9': 'March, 2019',
  'about_contant4_time9_txt1': 'Mainnet Launched',
  'about_contant4_time10': 'August, 2018',
  'about_contant4_time10_txt1': 'Maro Scan Launched',
  'about_contant4_time11': 'January, 2018',
  'about_contant4_time11_txt1': 'Maro Foundation Founded',

  // home
  'content1_txt': 'A secure mobile wallet app you can use manage your assets on the Maro Blockchain seamlessly',
  'content1_download': 'Download',

  'content2_h3': 'MARO Connect connects you with MARO',
  'content2_p': 'With MARO Connect, you can vote for Representatives, collect rewards, transfer assets, pay, and more',
  'content2_h5_1': 'Easy-to-use',
  'content2_txt_1': 'You can create an account and use MARO Connect just like that',
  'content2_h5_2': 'Safe and secure',
  'content2_txt_2': 'With your secure mobile device, you can keep your MARO safe and sound. If you lose your device, you can simply retrieve your account with your Mnemonic Keys or Private Key on a new device',
  'content2_h5_3': 'Fast transaction',
  'content2_txt_3': 'The Maro Blockchain allows for fast transactions and high throughput as it solves the bottleneck effect witnessed on other blockchain platforms',

  'content3_h3': 'MARO Connect is a mobile wallet designed user friendly',
  'content3_p': 'As an easy-to-use mobile wallet, MARO Connect allows you to securely store your asset. The Maro Blockchain builds a sustainable token economy and open infrastructure providing all global citizens a means to seamlessly connect to the global economy for even more opportunities for prosperity',
  'content3_link': 'See more>'
}



// WEBPACK FOOTER //
// ./src/i18n/en.js